import React, { useState, useEffect } from "react";
import { Edit } from "@material-ui/icons";
import { ApiService, getUserType, isPermissionExist } from "../services";
import GInfo from "../gComponents/gInfo";
import { Card, CardHead } from "../styledComponents/cardStyles";
import { GContent, GTableContent } from "../gComponents/gContent";
import { Switch, Route, useParams, Redirect } from "react-router-dom";
import GTabs from "../gComponents/gTabs";
import Bookings from "../bookings/ordersList";
import Addresses from "../components/addressList";
import Documents from "../components/documentsList";
import { useSnackbar } from "react-simple-snackbar";
import CustomerForm from "../forms/customerForm";
import useSettings from "../useSettings";
import GRouting from "../gComponents/gRouteBreadCrumbs";
import Modal from "react-modal";

const RoutLinks = [
  {
    title: "Customers",
    link: "/customers",
    state: "customer",
  },
];

export default function CustomerDetail(props) {
  let { customerId } = useParams();
  const [customerData, setCustomerData] = useState([]);
  const [customerInsights, setCustomerInsights] = useState({});
  const [typeValue, setTypeValue] = useState("bookings");
  const [ccvisible, setCcvisible] = useState(false);
  const settings = useSettings(true);
  const [openSnackbar] = useSnackbar();
  const customerRoutes = [
    getUserType() || isPermissionExist("order_index")
      ? {
          title: "bookings",
          link: "/customer/" + customerId + "/bookings",
          state: "customer",
        }
      : "",
    {
      title: "address",
      link: "/customer/" + customerId + "/address",
      state: "customer",
    },
    getUserType()
      ? {
          title: "documents",
          link: "/customer/" + customerId + "/documents",
          state: "customer",
        }
      : "",
  ];

  const getCustomerDetail = () => {
    ApiService({ method: "GET", route: "customers/" + customerId })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          setCustomerData(response.data.data);
          setCustomerInsights(response.data.data?.insights);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCustomerDetail();
  }, [props, customerId]);

  function handleChange(newValue) {
    setTypeValue(newValue);
  }

  function handleUpdateImage(imgValue, id, thumbValue) {
    console.log(imgValue);
    var data = { photo: imgValue, thumb_photo: thumbValue };
    ApiService({
      method: "PUT",
      route: "customers/" + customerId,
      body: data,
    }).then((response) => {
      console.log(response.data);
      if (response.data.status_code === 1) {
        setCustomerData(response.data.data);
      }
      openSnackbar(response.data.message);
      return;
    });
  }

  return (
    <div className="mainInnerView" style={{ padding: "20px 20px 0" }}>
      <GRouting links={RoutLinks} currentPage={customerData.title} />
      <GInfo
        id={customerData.id}
        title={customerData.title}
        key={customerData.id}
        className="headerInfo"
        imgType="user"
        imgEdit={
          getUserType() || isPermissionExist("customer_update") ? true : false
        }
        photo={customerData.photo}
        uploadImage={handleUpdateImage}
        style={{ width: "auto" }}
      />

      <br />

      <div
        style={{
          width: "30%",
          display: "inline-block",
          padding: "10px",
          verticalAlign: "top",
          boxSizing: "border-box",
        }}
      >
        <Card style={{ minHeight: "200px" }}>
          <CardHead>
            Contact Details
            {getUserType() || isPermissionExist("customer_update") ? (
              <Edit onClick={() => setCcvisible(true)} />
            ) : (
              ""
            )}
          </CardHead>
          <GContent title="Email" value={customerData.email} />
          <GContent title="Phone" value={customerData.phone || "-"} />
        </Card>

        <Card style={{ minHeight: "200px" }}>
          <CardHead>Smart Insights</CardHead>
          <GTableContent
            title="Last Booking"
            value={
              customerInsights.last_ordered
                ? customerInsights.last_ordered
                : "-"
            }
            align="right"
          />
          <GTableContent
            title="Open Bookings"
            value={customerInsights.open_orders}
            align="right"
          />
          <GTableContent
            title="Bookings Completed"
            value={customerInsights.completed_orders}
            align="right"
          />
        </Card>
        <Modal
          isOpen={ccvisible}
          className="modal modalRight"
          overlayClassName="modal-overlay"
          onRequestClose={() => setCcvisible(false)}
          style={{
            content: {
              width: "420px",
            },
          }}
          contentLabel="Customer Form Modal"
        >
          <CustomerForm
            ccvisible={ccvisible}
            setCcvisible={setCcvisible}
            data={customerData}
            onSubmit={getCustomerDetail}
          />
        </Modal>
      </div>

      <div
        style={{
          width: "calc(100% - 30%)",
          display: "inline-block",
          padding: "10px",
          verticalAlign: "top",
          boxSizing: "border-box",
        }}
      >
        <GTabs routes={customerRoutes} active={typeValue}></GTabs>

        <Switch>
          {getUserType() || isPermissionExist("order_index") ? (
            <Route exact path={"/customer/" + customerId + "/bookings"}>
              <Bookings
                onChange={handleChange}
                type="customer"
                value={customerId}
                title="customer_id"
              />
            </Route>
          ) : (
            ""
          )}
          <Route exact path={"/customer/" + customerId + "/address"}>
            <Addresses
              onChange={handleChange}
              type="customer"
              value={customerId}
              title="customer_id"
            />
          </Route>

          {getUserType() ? (
            <Route exact path={"/customer/" + customerId + "/documents"}>
              <Documents
                onChange={handleChange}
                type="customer"
                value={customerId}
                title="customer_id"
              />
            </Route>
          ) : (
            ""
          )}
          <Redirect
            to={"/customer/" + customerId + "/address"}
            from={"/customer/" + customerId + "/bookings"}
          />
          <Redirect
            to={"/customer/" + customerId + "/bookings"}
            from={"/customer/" + customerId + "/documents"}
          />
        </Switch>
      </div>
    </div>
  );
}
